import { useAtomValue } from 'jotai';
import { $FallbackGpToApk, $Locale, $UserAgent } from '@lemon8/web-app-shared/atom';
import { Language } from '@lemon8/web-app-shared/i18n';

import EN_IOS from './en-ios.png';
import JA_IOS from './ja-ios.png';
import ID_IOS from './id-ios.png';
import TH_IOS from './th-ios.png';
import MS_IOS from './ms-ios.png';
import VI_IOS from './vi-ios.png';

import EN_ANDROID from './en-android.png';
import JA_ANDROID from './ja-android.png';
import ID_ANDROID from './id-android.png';
import TH_ANDROID from './th-android.png';
import MS_ANDROID from './ms-android.png';
import VI_ANDROID from './vi-android.png';

import EN_APK from './apk/en.png';
import JA_APK from './apk/ja.png';
import ID_APK from './apk/id.png';
import TH_APK from './apk/th.png';
import MS_APK from './apk/ms.png';
import VI_APK from './apk/vi.png';

const BTN_MAP: { [key in Language]: [string, string, string] } = {
  [Language.en]: [EN_IOS, EN_ANDROID, EN_APK],
  [Language.id]: [ID_IOS, ID_ANDROID, ID_APK],
  [Language.ja]: [JA_IOS, JA_ANDROID, JA_APK],
  [Language.ms]: [MS_IOS, MS_ANDROID, MS_APK],
  [Language.th]: [TH_IOS, TH_ANDROID, TH_APK],
  [Language.vi]: [VI_IOS, VI_ANDROID, VI_APK],
  [Language.fil]: [EN_IOS, EN_ANDROID, EN_APK],
  [Language.fr]: [EN_IOS, EN_ANDROID, EN_APK],
};

export const useBtnPortrait = (): string => {
  const { language } = useAtomValue($Locale);
  const { isiOS, isMacOS } = useAtomValue($UserAgent);
  const fallbackGpToApkConfig = useAtomValue($FallbackGpToApk);

  if (isiOS || isMacOS) {
    return BTN_MAP[language][0];
  }

  if (fallbackGpToApkConfig.enable) {
    return BTN_MAP[language][2];
  }

  return BTN_MAP[language][1];
};
